import app from 'flarum/forum/app';
import { extend as extendComponent } from 'flarum/common/extend';
import TextEditorButton from 'flarum/common/components/TextEditorButton';
import { openingTag } from '../common/bbcodeUsage';
import extractText from 'flarum/common/utils/extractText';
export const extend = [];
app.initializers.add('ffans-bbcode-studio', () => {
  // Older cached formatter assets may not yet export setParameter.
  if (typeof s9e !== 'undefined') {
    s9e.TextFormatter.setParameter?.('L_BBCODE_STUDIO_SPOILER', extractText(app.translator.trans('ffans-bbcode-studio.forum.spoiler.title')));
  }
  extendComponent('flarum/common/components/TextEditor', 'toolbarItems', function (items) {
    const rules = app.forum.attribute('ffansBbcodeStudioToolbarRules') || [];
    if (rules.length === 0) return;
    rules.forEach((rule, index) => {
      const title = rule.buttonLabelTranslationKey ? app.translator.trans(rule.buttonLabelTranslationKey) : rule.buttonLabel;
      items.add(`ffans-bbcode-studio-${rule.id}`, m(TextEditorButton, {
        icon: rule.icon,
        title: title,
        onclick: () => insertRule(this, rule)
      }), 20 - index // random picked basic priority, doesn't mean anything.
      );
    });
  });
});
function insertRule(editorComponent, rule) {
  const composer = editorComponent.attrs.composer;
  const editor = composer.editor;
  const [start, end] = editor.getSelectionRange();
  const currentValue = String(editorComponent.value || '');
  const selection = currentValue.slice(start, end);
  const open = openingTag(rule.tag, rule.exampleAttributes || {});
  const close = `[/${rule.tag}]`;
  const content = selection || rule.example || '';
  editor.insertBetween(start, end, `${open.value}${content}${close}`, false);
  if (!selection) {
    editor.moveCursorTo(start + open.value.length);
  }
}